import { render } from "./index.vue?vue&type=template&id=939a8e5e"
const script = {}

import "./index.vue?vue&type=style&index=0&id=939a8e5e&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/SZGC/M2FE/sjyunc-demo-spa/portal-mall-spa-prod/fe_mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__